import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Hidden from "@insite/mobius/Hidden";
import Icon, { IconPresentationProps } from "@insite/mobius/Icon";
import Link from "@insite/mobius/Link";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React from "react";
import { css } from "styled-components";

const enum fields {
    phoneNumber = "phoneNumber",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.phoneNumber]: string;
    };
}

export interface HeaderPhoneNumberStyles {
    container?: InjectableCss;
    mobileWrapper?: InjectableCss;
    phoneNumberText?: TypographyPresentationProps;
    phoneNumberTextMobile?: TypographyPresentationProps;
    icon?: IconPresentationProps;
}

export const headerPhoneNumberStyles: HeaderPhoneNumberStyles = {
    container: {
        css: css`
            text-align: right;
            width: 100%;
            padding: 0 10px;

            ${({ theme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        css`
                            padding: 0;
                        `,
                    ],
                    "max",
                )}
        `,
    },
    mobileWrapper: {
        css: css`
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: center;
        `,
    },
    phoneNumberText: {
        css: css`
            color: ${getColor("secondary.main")};
            font-size: 24px;
        `,
    },
    phoneNumberTextMobile: {
        css: css`
            color: ${getColor("secondary.main")};
            font-size: 24px;
            &:hover {
                text-decoration: underline;
            }
        `,
    },
    icon: {
        src: "Phone",
        color: "secondary.main",
        css: css`
            margin-right: 10px;
        `,
    },
};

const HeaderPhoneNumber = ({ fields }: OwnProps) => {
    const styles = headerPhoneNumberStyles;

    const phoneLinkUrl = `tel:${fields.phoneNumber
        .replace("(", "")
        .replace(")", "")
        .replace("-", "")
        .replace(" ", "")}`;

    return (
        <StyledWrapper {...styles.container} data-test-selector="HeaderPhoneNumber_container">
            <Hidden above="md" {...styles.mobileWrapper}>
                <Icon {...styles.icon}></Icon>
                <Link href={phoneLinkUrl}>
                    <Typography {...styles.phoneNumberTextMobile}>{fields.phoneNumber}</Typography>
                </Link>
            </Hidden>
            <Hidden below="lg">
                <Typography {...styles.phoneNumberText}>{fields.phoneNumber}</Typography>
            </Hidden>
        </StyledWrapper>
    );
};

const basicTab = {
    displayName: "Basic",
    sortOrder: 0,
};

const widgetModule: WidgetModule = {
    component: HeaderPhoneNumber,
    definition: {
        group: "Header",
        icon: "presentation-screen",
        fieldDefinitions: [
            {
                name: fields.phoneNumber,
                editorTemplate: "TextField",
                defaultValue: "",
                fieldType: "Translatable",
                tab: basicTab,
                sortOrder: 0,
            },
        ],
    },
};

export default widgetModule;
